import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { InputSubmitButton, GetStartedHeading } from "../../../components";

export const LoggedOutJiraFree = () => {
    const version = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    )
        ? LayoutVersion.V2
        : LayoutVersion.V1;

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm" version={version}>
                <GetStartedHeading productName="Jira" />
                <p css={subHeaderCss}>
                    <FormattedMessage
                        id="signupForm.accountCreation.subHeaderText"
                        defaultMessage="It’s free for up to 10 users - no credit card needed."
                    />
                </p>
                <FeatureExposed
                    experimentKey="jfind-1185-signup-button-update"
                    group="Test"
                >
                    <AccountCreation
                        Input={<InputSubmitButton />}
                        Submit={null}
                    />
                </FeatureExposed>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
